import FormGroup from "@material-ui/core/FormGroup";
import { Fragment, useState } from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { useTranslation } from "react-i18next";
import { useBillingAddress } from "./hooks/useBillingAddress";
import { Address } from "@common/eircode/Address";
import { Loader } from "@common/handleErrorAndLoading/Loader";
import { IUserAddress } from "@common/eircode/Interface/IAddressForm";
import { Modal } from "@common/Modal/Modal";

interface IParams {
    userAddress: IUserAddress;
    getUserAddress(): void;
}

export const BillingAddressForm = (props: IParams) => {
    const { userAddress, getUserAddress } = props;
    const { t } = useTranslation(["profile", "glossary", "common"]);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [disableEdit, setDisableEdit] = useState<boolean>(false);

    const {
        submitUserAddress,
        formMethods,
        editing: { isEditing, setIsEditing },
        updateUserAddressState,
    } = useBillingAddress(userAddress, setIsModalOpen, setDisableEdit);

    const cancel = () => {
        setIsEditing(false);
        getUserAddress();
    };

    return (
        <>
            <form onSubmit={submitUserAddress}>
                <FormGroup row>
                    <Address
                        addressForm={formMethods}
                        isEditing={isEditing}
                        isLoading={updateUserAddressState.isLoading}
                        prefix={"billingAddress"}
                    />
                </FormGroup>
                {isEditing && (
                    <Fragment>
                        {updateUserAddressState.error && (
                            <Typography color="error" variant="body2">
                                {t("common:genericError")}
                            </Typography>
                        )}
                        <Grid className="profileBilling__buttons" container>
                            {!updateUserAddressState.isLoading && (
                                <Fragment>
                                    <Grid item sm={2} xs={4}>
                                        <Button
                                            color="secondary"
                                            fullWidth
                                            size="large"
                                            type="button"
                                            variant="outlined"
                                            onClick={cancel}
                                        >
                                            {t("common:cancel")}
                                        </Button>
                                    </Grid>
                                    <Grid item sm={2} xs={4}>
                                        <Button
                                            color="secondary"
                                            fullWidth
                                            size="large"
                                            type="submit"
                                            variant="contained"
                                        >
                                            {t("glossary:save")}
                                        </Button>
                                    </Grid>
                                </Fragment>
                            )}
                            {updateUserAddressState.isLoading && (
                                <Grid item sm={2} xs={4}>
                                    <Loader size={40} />
                                </Grid>
                            )}
                        </Grid>
                    </Fragment>
                )}
                {!isEditing && (
                    <Grid className="profileBilling-edit__button" container>
                        <Grid item sm={2} xs={4}>
                            <Button
                                disabled={!userAddress.canEdit || disableEdit}
                                color="secondary"
                                fullWidth
                                size="large"
                                variant="contained"
                                onClick={() => setIsEditing(true)}
                            >
                                {t("profile:edit")}
                            </Button>
                        </Grid>
                    </Grid>
                )}
            </form>
            <Modal
                close={() => setIsModalOpen(false)}
                confirm={() => setIsModalOpen(false)}
                confirmLabel={t("glossary:close")}
                content={t("profile:saveAddressModal")}
                isModalOpen={isModalOpen}
                title=""
            />
        </>
    );
};
